<template>
  <v-container
    fluid
    class="pa-0 d-flex flex-column align-center justify-center"
    :class="$vuetify.theme.dark ? 'background_light' : 'background_normal'"
    style="height: 100vh"
  >
    <admin-login class="mx-auto my-auto" />
  </v-container>
</template>

<script>
import AdminLogin from "@/components/Authorization/AdminLogin.vue";
import setMeta from "@/utils/setMeta";

export default {
  components: {
    AdminLogin,
  },
  created() {
    setMeta({
      title: "관리자 로그인",
      description: "메이드올 관리자 페이지 로그인 화면입니다.",
      image:
        "https://firebasestorage.googleapis.com/v0/b/madeall.appspot.com/o/Assets%2FOG%2Flogin.png?alt=media&token=171e59e8-a13a-43eb-83f1-5f2b0a5629a6",
    });
  },
};
</script>
